import React from 'react'
import fileSearch from '../../assets/file-search.svg';
import { t } from 'i18next';

export const EmptyStateOne = ({ message = t('NO_DATA') }) => {
    return (
        <div className="d-flex flex-column align-items-center">
            <img src={fileSearch} alt="" style={{ maxWidth: '83px' }} />
            <p className="mt-2">{message}</p>
        </div>
    )
}
